var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patientDetailComponent',{attrs:{"isMy":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }